import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import hashFill from '@iconify/icons-eva/hash-fill';
import { Icon } from '@iconify/react';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import {
  Autocomplete,
  Box,
  Button,
  DialogActions,
  Fade,
  FormControlLabel,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListSubheader,
  Menu,
  MenuItem,
  Modal,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import SvgIcon from "@mui/material/SvgIcon";
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import _ from 'lodash';
import toast from 'react-hot-toast';
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg";
import { ReactComponent as InputSearchIcon } from "../assets/icons/icon-feather-search.svg";
import { ReactComponent as MoreIcon } from "../assets/icons/icon-more.svg";
import { ReactComponent as VisualizeIcon } from "../assets/icons/icon-visualize.svg";
import Popup from '../components/Popup';
import { CalculatedFieldsV2 } from '../components/_report/cards';
import { addVersion } from '../config/services/config';
import { getDataSource } from '../config/services/dataSource';
import { getDatasets } from '../config/services/datasets';
import { deleteMeasure, getMeasureById, getMeasuresList, getMeasuresLists, updateMeasure } from '../config/services/measures';
import { useMeasureListContext } from "../contexts/MeasureListContext";
import GraphTypes from '../layouts/graph/GraphTypes';
import StaticGraphTypes from '../layouts/graph/StaticGraphTypes';
import { debouncingFn } from '../utils/Reusables';
import { DecryptData, EncryptData } from "../utils/encryptDecrypt";
import moment from 'moment';
import { CURRENCIES } from '../constants/filterType';

const ParseSvgIcon = ({ component }) => <SvgIcon component={component} width={100} height={100} />
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
  },
}))
const useStyles = makeStyles((theme) => ({
  fieldMenu: {
    boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
  },
  autoCompleteInp: {
    fontWeight: 'normal'
  },
  fieldBtn: {
    position: 'absolute',
    right: '5px',
    bottom: '3px',
    cursor: 'pointer',
    minWidth: 'auto',
  },
  reportFieldList: {
    width: '100%',
    backgroundColor: '#fff',
    maxHeight: '350px',
    minHeight: '350px',
    marginBottom: '1rem',
    overflow: 'auto',
    marginTop: '5px',
    borderRadius: '4px',
  },
  bgWhite: {
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  grey_bg: {
    backgroundColor: '#f1f1f1',
  },
  formInput: {
    paddingLeft: 0,
    '&::placeholder': {
      paddingLeft: '-10px',
    }
  },
  searchFieldListItem: {
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    '&:hover': {
      background: "#f1f1f1",
      zIndex: 9,
      "& $listItemDescription": {
        visibility: 'visible'
      },
      "& $searchFieldListMoreIcon": {
        visibility: 'visible'
      }
    },

  },
  listItemDescription: {
    display: 'none',
    '&:hover': {
      display: 'block'
    }
  },
  searchFieldListMoreIcon: {
    visibility: 'hidden',
    '&:hover': {
      visibility: 'visible'
    }
  }

}));

// ----------------------------------------------------------------------
export default function ReportVisualizeSettings({ isOpenSidebar, children, reportDetails, updateReportDetails, isCalculatedFieldOpen, setCommonFields, currentUserType }) {
  const classes = useStyles()
  const { addMeasureListByDataset } = useMeasureListContext();
  const [datasetsList, setDatasetsList] = useState([]);
  const [datasetSelectedId, setDatasetSelectedId] = useState(null);
  const [datasetSelectedName, setDatasetSelectedName] = useState(null);
  const [measureList, setMeasureList] = useState([])
  const [searchMeasure, setSearchMeasure] = useState(null)
  const [searchDataset,setSearchDataset] = useState('')
  const [loadingDataset,setLoadingDataset] = useState(false)
  const [selectedMeasureIds, setSelectedMeasureIds] = useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [dateAnchorEl, setDateAnchorEl] = useState(null)
  const [isEditCalculatedFields, setIsEditCalculatedFields] = useState(false)
  const [calculatedField, setCalculatedField] = useState('')
  const [calculatedDisplayName, setCalculatedDisplayName] = useState('')
  const [calculatedDescription, setCalculatedDescription] = useState('')
  const [calculatedValue, setCalculatedValue] = useState('')
  const [displayCalculatedField, setDisplayCalculatedField] = useState('')
  const [measureId, setMeasureId] = useState('')
  const [openPopup, setOpenPopup] = useState(false)
  const [selectedMeasure, setSelectedMeasure] = useState({})
  const [confirmDatasetChange, setConfirmDatasetChange] = useState(false)
  const [tempNewSelectedDataSet, setTempNewSelectedDataSet] = useState('')
  const [formatAnchorEl, setFormatAnchorEl] = useState(null);
  const [subFormatAnchorEl, setSubFormatAnchorEl] = useState(null);
  const [formatCurrencyAnchorEl, setCurrencyFormatAnchorEl] = useState(null);
  const [subFormatCurrencyAnchorEl, setSubFormatCurrencyAnchorEl] = useState(null);
  const [dateSelectAnchorEl, setDateSelectAnchorEl] = useState(null);
  const [editMeasureObj, setEditMeasureObj] = useState({})
  const [selectedDataSetObj, setSelectedDataSetObj] = useState({});
  const [datasetOptions, setDatasetOptions] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false)
  let [selectedChart, setSelectedChart] = useState(reportDetails?.reportDetails?.chartType)
  const [dataSourceList, setDataSourceList] = useState([])
  const [selectedDataSource, setSelectedDataSource] = useState({ dbName: 'All' })
  const [filteredDataSetList, setFilteredDataSetList] = useState([])
  const [tempDataSourceSelected, setTempDataSourceSelected] = useState('')
  const [confirmDataSourceChange, setConfirmDataSourceChange] = useState(false)

  const [showJoinFlag,setShowJoinFlag] = useState(false)


  let mapSelectedMeasureList = () => {
    let selectedMeasures = []
    selectedMeasures = [...reportDetails.reportDetails.measures.map(item => item.fieldId), ...reportDetails.reportDetails.dimensions.map(item => item.fieldId)]
    setSelectedMeasureIds(selectedMeasures)
  }

  const handleCancelDelete = (e) => {
    setDeletePopup(false)
  }

  const handleChangeDataSource = (value) => {
    setSelectedDataSource(value)
    const { _id, projectId, dbName } = value;

    if (datasetOptions?.length) {
      if (dbName === 'All') {
        setFilteredDataSetList([])
        return
      }
      else if (dbName === 'Athena') {
        const filtered = datasetOptions.filter(sets => !sets?.dataSource)
        setFilteredDataSetList(filtered)
        return
      }
      const filtered = datasetOptions.filter(sets => (sets?.dataSource && sets?.dataSource?._id === _id))
      setFilteredDataSetList(filtered)
    }
  }

  const submitDeleteField = async (e) => {
    try {
      let params = { measureId: selectedMeasure?._id }
      let loggedInUser = DecryptData(localStorage.getItem('s_uuid'))
      let { createdBy } = selectedMeasure

      if (createdBy !== loggedInUser && ['superadmin', 'superadmin@extramarks.com'].indexOf(loggedInUser) < 0) {
        toast.error("Not Authorised")
        setDeletePopup(false)
        return
      } else {
        const res = await deleteMeasure(params)
        await addVersion({ version: new Date().getTime().toString() })
        toast.success(res.message)
        fetchMeasureList()
        setDeletePopup(false)
      }
    }
    catch (error) {
      toast.error(error)
    }
  }

  const handleSubFormatCurrencyMenu = (e) => {
    e.stopPropagation()
    setSubFormatCurrencyAnchorEl(e.currentTarget)
  }

  const handleFormatClose = () => {
    setFormatAnchorEl(null);
    setSubFormatAnchorEl(null);
    setSubFormatCurrencyAnchorEl(null);
  };

  const handleDateClose = () => {
    setDateAnchorEl(null);
  }

  const handleDateSelectClose = () => {
    setDateSelectAnchorEl(null)
  }

  const handleClick = (event, measure) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
    setSelectedMeasure(measure)
  }

  const handleClose = (e) => {
    e.stopPropagation()
    setAnchorEl(null)
  }


  const fetchDatasetsList = () => {
    setLoadingDataset(true)
    let params = {search:searchDataset, pageNo: 0,count: 50, sortKey: 'displayName', sortOrder: 1,populate:'false' }
    getDatasets(params)
      .then((res) => {
        let datsetOptionsArray = [...res.result]
        datsetOptionsArray = datsetOptionsArray.map(obj => {
          return {
            _id: obj?._id,
            label: obj?.displayName ?? null,
            dataSetName: obj?.displayName ?? null,
            dataSource: obj?.dataSource ?? null,
            description: obj?.dataSetDescription || obj?.description,
            customJoin: obj?.customJoin ?? []
          }
        })
        //console.log(datsetOptionsArray)
        setDatasetsList(res.result);
        setDatasetOptions(datsetOptionsArray)
        //console.log(reportDetails.reportDetails?.dataSetId?._id)
        if (reportDetails.reportDetails?.dataSetId?._id && !searchDataset) {
          setSelectedDataSetObj(limitedDatasetDetails(reportDetails?.reportDetails?.dataSetId))
          setDatasetSelectedId(reportDetails?.reportDetails?.dataSetId?._id);
          setDatasetSelectedName(reportDetails?.reportDetails?.dataSetId?.dataSetName)
        }else if(!searchDataset) {
          let firstDataSet = JSON.parse(DecryptData(localStorage.getItem("selectedDataSetObj"))) ?? res?.result[0]          
          setSelectedDataSetObj(limitedDatasetDetails(firstDataSet))
          setDatasetSelectedId(firstDataSet._id);
          setDatasetSelectedName(firstDataSet.dataSetName);
          reportDetails.reportDetails.dataSetId = firstDataSet
          updateReportDetails({ reportDetails: reportDetails.reportDetails });          
        }
        setLoadingDataset(false)
      });
  }

  const limitedDatasetDetails = (datasetObj) => {
    return {
      _id: datasetObj?._id,
      label: datasetObj?.displayName ?? datasetObj?.dataSetName ?? null,
      dataSetName: datasetObj?.dataSetName,
      description: datasetObj?.description,
      dataSource: datasetObj?.dataSource ?? null,
      customJoin: datasetObj?.customJoin ?? []
    }
  }

  const getCalculatedMeasures = async (e) => {
    e.stopPropagation()
    setAnchorEl(null)
    try {
      let params = { measureId: selectedMeasure?._id }
      const res = await getMeasureById(params)
      if (res.result) {
        setCalculatedField(res?.result?.name)
        setCalculatedValue(res?.result?.calculatedField)
        setDisplayCalculatedField(res?.result?.displayCalculatedField)
        setCalculatedDisplayName(res?.result?.displayName || '')
        setCalculatedDescription(res?.result?.description)
        setMeasureId(res.result._id)
        setIsEditCalculatedFields(true)
        setOpenPopup(true)
      }
    } catch (error) {
      toast.error(error)
    }
  }

  const closeCalcltdFldDialog = () => {
    setCalculatedField('')
    setCalculatedValue('')
    setMeasureId('')
    setIsEditCalculatedFields(false)
    setOpenPopup(false)
  }


  const deleteCalculatedFields = async (e) => {
    e.stopPropagation()
    setDeletePopup(true)
    setAnchorEl(null)
  }

  const handleConfirmChangeDataSource = (e, value) => {
    if (value && value?.dbName === 'All') {
      handleChangeDataSource(value)
      return
    }
    setTempDataSourceSelected(value)
    setConfirmDataSourceChange(true)
  }


  const handleConfirmDataSetChange = (e, value) => {    
    let { measures, dimensions, reportFilters } = reportDetails?.reportDetails || {}

    if (measures?.length || dimensions?.length || reportFilters?.length) {
      setTempNewSelectedDataSet(value?._id)
      setConfirmDatasetChange(true)
    }
    else {
      datasetSelected(value?._id)
    }
  }

  const handleDatasetSearch = (e, value) => {
    //console.log(e.target.value)
    setSearchDataset(e.target.value)
  }

  const handleSubmitDataSourceChange = (data) => {
    switch (data.type) {
      case 'cancel':
        setTempDataSourceSelected('')
        setConfirmDataSourceChange(false)
        break
      case 'change':
        setConfirmDataSourceChange(false)
        reportDetails.reportDetails.measures = []
        reportDetails.reportDetails.dimensions = []
        reportDetails.reportDetails.reportFilters = []
        reportDetails.reportDetails.timeDimensions = []
        reportDetails.reportDetails.pivotConfig = {
          xAxis: {
            id: "xAxis",
            list: [],
            type: "dimensions",
            label: 'X Axis'
          },
          value: {
            id: "value",
            list: [{ id: "1", text: "measures", type: "measures" },],
            label: 'Value'
          },
          lines: {
            id: "Lines",
            list: [],
            label: 'Lines'
          },
          group: {
            id: "group",
            list: [],
            label: 'Group'
          }
        }

        reportDetails.reportDetails.orderBy = []
        reportDetails.reportDetails.dataSetId = ""
        reportDetails.reportDetails.reportHyperlink = [{ hyperlinkColumn: '', hyperlinkReportId: {}, hyperlinkFilters: [] }]
        setCommonFields([])
        setSelectedDataSetObj({})
        setMeasureList([])
        updateReportDetails({ reportDetails: reportDetails.reportDetails });
        handleChangeDataSource(tempDataSourceSelected)
        break
    }
  }

  const handleSubmitDataSetChange = (data) => {
    switch (data.type) {
      case 'cancel':
        setTempNewSelectedDataSet('')
        setConfirmDatasetChange(false)
        break
      case 'change':
        datasetSelected(tempNewSelectedDataSet)
        setConfirmDatasetChange(false)
        break
    }
  }

  const clearSelections = (reportDetails,selectedDataSetObj) => {
    reportDetails.reportDetails.dataSetId = selectedDataSetObj
    reportDetails.reportDetails.measures = []
    reportDetails.reportDetails.dimensions = []
    reportDetails.reportDetails.reportFilters = []
    reportDetails.reportDetails.timeDimensions = []
    reportDetails.reportDetails.pivotConfig = {
      xAxis: {
        id: "xAxis",
        list: [],
        type: "dimensions",
        label: 'X Axis'
      },
      value: {
        id: "value",
        list: [{ id: "1", text: "measures", type: "measures" },],
        label: 'Value'
      },
      lines: {
        id: "Lines",
        list: [],
        label: 'Lines'
      },
      group: {
        id: "group",
        list: [],
        label: 'Group'
      }
    }

    reportDetails.reportDetails.orderBy = []
    reportDetails.reportDetails.reportHyperlink = [{ hyperlinkColumn: '', hyperlinkReportId: {}, hyperlinkFilters: [] }]
    setCommonFields([])

    return reportDetails
  }

  const datasetSelected = (value) => {
    let selectedDataSetObj = datasetsList.find(dataSet => dataSet._id === value)
    if (selectedDataSetObj) {
      setDatasetSelectedId(selectedDataSetObj._id);
      setDatasetSelectedName(selectedDataSetObj.dataSetName);
      setSelectedDataSetObj(limitedDatasetDetails(selectedDataSetObj))
      if (!reportDetails?.reportDetails?._id) {
        localStorage.setItem('selectedDataSetObj', EncryptData(JSON.stringify(selectedDataSetObj)))
      }
      reportDetails.reportDetails.dataSetId = selectedDataSetObj
      let repObj = clearSelections(reportDetails,selectedDataSetObj)

      updateReportDetails({ reportDetails: repObj.reportDetails });
    }
    return
  }

  const fetchMeasureList = () => {
    if (datasetSelectedId) {
      setMeasureList([])
      let joinedDatasets = []      
      if(reportDetails.reportDetails?.joinFlag && selectedDataSetObj?.customJoin && selectedDataSetObj?.customJoin.constructor === Array){
        joinedDatasets = selectedDataSetObj?.customJoin.map(obj => obj.dataSetId)
      }    
      let params = { dataSetId: [datasetSelectedId,...joinedDatasets], search: searchMeasure, sortKey: 'displayName', sortOrder: 1 }
      getMeasuresLists(params)
        .then((res) => {
          setMeasureList(res.result);
          addMeasureListByDataset(datasetSelectedId, res.result)
        });
    }
  }

  const setChartHandler = (selected) => {
    reportDetails.reportDetails.chartType = selected.value;
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const setClassNameMeasureReport = (measure) => {
    let findInMeasures = reportDetails?.reportDetails?.measures?.find(item => item.fieldId === measure._id)
    let findInDimensions = reportDetails?.reportDetails?.dimensions?.find(item => item.fieldId === measure._id)

    if (findInMeasures || findInDimensions)
      return "visualize_list_text"

    return "";
  }

  const clickMeasureListHandler = (measure) => {
    let dataExit = false;
    let { pivotConfig, dataSetId } = reportDetails?.reportDetails
    let datasetSelectedName = measure.dataset.dataSetName
    if (measure.dataSetType === "MEASURE") {
      for (let i = 0; i < reportDetails?.reportDetails?.measures.length; i++) {
        if (reportDetails?.reportDetails?.measures[i]?.fieldId === measure?._id) {
          dataExit = true;
        }
      }

      if (dataExit) {
        reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item?.fieldId !== measure?._id)
        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== datasetSelectedName+ "." + measure?.name)
        reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(item => item?.text !== datasetSelectedName + "." + measure?.name)

        if (pivotConfig?.['lines']?.list) {
          reportDetails.reportDetails.pivotConfig['lines'].list = pivotConfig['lines']?.list.filter(item => item?.text !== datasetSelectedName + "." + measure?.name)
        }
        if (pivotConfig?.['group']?.list) {
          reportDetails.reportDetails.pivotConfig['group'].list = pivotConfig['group']?.list.filter(item => item?.text !== datasetSelectedName + "." + measure?.name)
        }
      }
      else {
        reportDetails?.reportDetails?.measures.push({
          fieldName: datasetSelectedName + "." + (measure?.name),
          fieldId: measure?._id,
          displayName: measure?.displayName

        });
        reportDetails?.reportDetails?.pivotConfig['value']?.list.push({
          text: datasetSelectedName + "." + (measure.name),
          id: measure._id,
          displayName: measure?.displayName,
          type: "measures",
          visibleInFieldwell: false
        })

        // check if order by exist with same measure
        let index = reportDetails?.reportDetails?.orderBy.findIndex(item => item?.content?.key === datasetSelectedName + "." + measure?.name)
        if (index > -1) {
          reportDetails.reportDetails.orderBy[index] = {
            id: measure?._id,
            content: {
              key: datasetSelectedName + "." + measure?.name,
              displayName: measure?.displayName,
              order: reportDetails?.reportDetails?.orderBy[index]?.content?.order
            }
          }
        } else {
          reportDetails?.reportDetails?.orderBy.push({
            id: measure?._id,
            content: {
              key: datasetSelectedName + "." + measure?.name,
              displayName: measure?.displayName,
              order: 'desc'
            }
          })
        }
      }
    }
    else {
      for (let i = 0; i < reportDetails?.reportDetails?.dimensions.length; i++) {
        if (reportDetails?.reportDetails?.dimensions[i]?.fieldId === measure?._id) {
          dataExit = true;
        }
      }
      if (dataExit) {
        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails.dimensions.filter(item => item?.fieldId !== measure?._id)
        reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(item => item?.text !== datasetSelectedName + "." + measure?.name)
        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== datasetSelectedName + "." + measure?.name)
        reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(item => item?.text !== datasetSelectedName + "." + measure?.name)

        if (pivotConfig?.['group']?.list) {
          reportDetails.reportDetails.pivotConfig['group'].list = pivotConfig['group']?.list.filter(item => item?.text !== datasetSelectedName + "." + measure?.name)
        }

      } else {
        reportDetails.reportDetails.dimensions.push({
          fieldName: datasetSelectedName + "." + (measure.name),
          fieldId: measure._id,
          displayName: measure?.displayName
        });
        reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.push({
          text: datasetSelectedName + "." + (measure.name),
          id: measure._id,
          displayName: measure?.displayName,
          type: "dimensions"
        })
        if (measure?.type === 'number') {
          reportDetails?.reportDetails?.orderBy.push({
            id: measure?._id,
            content: {
              key: datasetSelectedName + "." + measure?.name,
              displayName: measure?.displayName,
              order: 'desc'
            }
          })
        }
        else if (measure?.type === 'string') {
          reportDetails?.reportDetails?.orderBy.push({
            id: measure?._id,
            content: {
              key: datasetSelectedName + "." + measure?.name,
              displayName: measure?.displayName,
              order: 'asc'
            }
          })
        }
        else {
          reportDetails?.reportDetails?.orderBy.push({
            id: measure?._id,
            content: {
              key: datasetSelectedName + "." + measure?.name,
              displayName: measure?.displayName,
              order: 'desc'
            }
          })
        }
      }
    }

    if (reportDetails?.reportDetails?.settings.groupBySettings.length) {
      let index = reportDetails?.reportDetails?.settings.groupBySettings.findIndex(item => {
        return item?.concatAt.split('.')[1] === (measure?.name || measure?.displayName);
      });
      if (index > -1) {
        reportDetails.reportDetails.settings.groupBySettings.splice(index, 1);
      }
     
    }

    if (reportDetails?.reportDetails?.settings.groupBySettings.length) {
      reportDetails.reportDetails.settings.groupBySettings = reportDetails?.reportDetails?.settings?.groupBySettings?.map(obj => {
        obj.concatWith = obj?.concatWith?.filter(element => element.split('.')[1] !== (measure?.name || measure?.displayName));
        return obj;
      });
    }

     
    if (reportDetails?.reportDetails?.settings.truncateSettings.length) {
      reportDetails.reportDetails.settings.truncateSettings = reportDetails?.reportDetails?.settings?.truncateSettings?.filter(obj => {
        return obj.truncateAt.split('.')[1] !== (measure?.name || measure?.displayName);
      });
    }


    mapSelectedMeasureList()
    updateReportDetails({ reportDetails: reportDetails.reportDetails });
  }


  const handleFormatMenu = (e) => {
    e.stopPropagation()
    setFormatAnchorEl(e.currentTarget)
  }

  const handleSubFormatMenu = (e) => {
    e.stopPropagation()
    setSubFormatAnchorEl(e.currentTarget)
  }

  // const handleFormatSelect = async (e) => {
  //   e.stopPropagation();
  //   const selectedFormat = e?.target?.attributes?.value?.value;
  //   if (selectedFormat) {
  //     for (let meas of reportDetails?.reportDetails?.measures) {
  //       if (meas?.fieldId === selectedMeasure?._id) {
  //         meas.fieldFormat = selectedFormat
  //         break;
  //       }
  //     }
  //     updateReportDetails({ reportDetails: reportDetails.reportDetails })
  //     let params = { measureId: selectedMeasure?._id, format: selectedFormat }
  //     const res = await updateMeasure(params)
  //     await addVersion(new Date().getTime().toString())
  //     handleFormatClose()
  //     toast.success(res.message)
  //   }
  // }

  const handleSubFormatSelect = async (e, type) => {
    e.stopPropagation();
    const  selectedFormat  = e?.target?.attributes?.value?.value
    if (selectedFormat) {
      for (let meas of reportDetails?.reportDetails?.measures) {
        if (meas?.fieldId === selectedMeasure?._id) {
          meas.fieldFormat = selectedFormat
          break;
        }
      }
    }
    if (selectedFormat) {
            let clonedReportDetails = _.cloneDeep(reportDetails?.reportDetails)
            switch (type) {
                case 'currency':
                    clonedReportDetails.settings.dataFormat.currencyFormat = selectedFormat
                    clonedReportDetails.settings.dataFormat.timeFormat = ''
                    clonedReportDetails.settings.dataFormat.format = ''
                    break;
                case 'time':
                    clonedReportDetails.settings.dataFormat.timeFormat = selectedFormat
                    clonedReportDetails.settings.dataFormat.currencyFormat = ''
                    clonedReportDetails.settings.dataFormat.format = ''
                    break;
                default:
                    clonedReportDetails.settings.dataFormat.format = selectedFormat
                    clonedReportDetails.settings.dataFormat.timeFormat = ''
                    clonedReportDetails.settings.dataFormat.currencyFormat = ''
                    break
                  }
                  updateReportDetails({ reportDetails: clonedReportDetails })

            if((selectedFormat === 'percent') || (selectedFormat === 'number')) {
              let params = { measureId: selectedMeasure?._id, format: selectedFormat }
              const res = await updateMeasure(params)
              await addVersion(new Date().getTime().toString())
              toast.success(res.message)
            }else {
              toast.success("Measure updated successfully")
            }
            handleFormatClose()

        }
  
  }

  const fetchDataSourceList = () => {
    let params = {}
    getDataSource(params).then((res) => {
      let sourceArr = [
        { dbName: 'All' },
        { dbName: 'Athena' }
      ]
      sourceArr.push(...res?.result)
      setDataSourceList(sourceArr);
    });
  }

  // useEffect(() => fetchDataSourceList(),[])

  useEffect(() => {
    let fetchReq = setTimeout(fetchDatasetsList,500)
    //console.log(reportDetails)
    return () => clearTimeout(fetchReq)
  }, [searchDataset])

  useEffect(debouncingFn(fetchMeasureList), [datasetSelectedId, searchMeasure,reportDetails?.reportDetails?.joinFlag]);
  useEffect(() => { mapSelectedMeasureList() }, []);

  const addCalculatedField = () => {
    setIsEditCalculatedFields(false)
    setOpenPopup(true)
  }
  const handleSearchMeasure = (e) => {
    let { value } = e.target
    setSearchMeasure(value)
  }

  const handleDateMenu = (e, measure) => {
    e.stopPropagation()
    setDateAnchorEl(e.currentTarget)
    setSelectedMeasure(measure)
  }


  const handleDateSelectMenu = (e) => {
    e.stopPropagation()
    setDateSelectAnchorEl(e.currentTarget)
  }

  const handleDateFormatSelect = async (e) => {
    e.stopPropagation();
    const selectedFormat = e?.target?.attributes?.value?.value;
    if (selectedFormat) {
      for (let dim of reportDetails?.reportDetails?.dimensions) {
        if (dim?.fieldId === selectedMeasure?._id) {
          dim.dateFormat = selectedFormat
          break;
        }
      }
      updateReportDetails({ reportDetails: reportDetails.reportDetails })
      handleDateSelectClose()
      handleDateClose()
    }
  }
  const handleTimeFormatSelect = async (e) => {
    e.stopPropagation();
    const selectedFormat = e?.target?.attributes?.value?.value;
    if (selectedFormat) {
      for (let dim of reportDetails?.reportDetails?.dimensions) {
        if (dim?.fieldId === selectedMeasure?._id) {
          dim.timeFormat = selectedFormat
          dim.timeFormatType = selectedMeasure?.comment
          break;
        }
      }
      updateReportDetails({ reportDetails: reportDetails.reportDetails })
      handleDateSelectClose()
      handleDateClose()
    }
  }

  const editMeasureDescription = async (type) => {
    switch (type) {
      case 'open':
        setEditMeasureObj({ openPopup: true })
        setAnchorEl(null)
        break
      case 'cancel':
        setEditMeasureObj({ openPopup: false })
        setSelectedMeasure({})
        break
      case 'submit':
        let params = { measureId: selectedMeasure?._id, displayName: selectedMeasure?.displayName ? selectedMeasure?.displayName : selectedMeasure?.name, description: selectedMeasure?.description }

        if (!validateFieldName(selectedMeasure?.displayName === undefined ? selectedMeasure?.name : selectedMeasure?.displayName)) {
          return
        }

        const res = await updateMeasure(params)

        if (res?.result) {
          handleReportDisplayName(selectedMeasure)
          toast.success(res.message)
          setEditMeasureObj({ openPopup: false })
          setSelectedMeasure({})
          fetchMeasureList()
        }
        else if (res?.data?.statusCode === 0) {
          toast.error(res?.data?.error?.errorMessage)
        }
        break
    }
  }

  const validateFieldName = (fieldName) => {
    const format = /[^a-zA-Z ]/g;

    if (!fieldName) {
      toast.error("Field Name can't be empty!")
      return false
    }
    else if (format.test(fieldName)) {
      toast.error("Field Name can't have speacial character!")
      return false
    }

    return true
  }

  // const renderHideColumnMenu = () => {
  //   if (selectedMeasure) {
  //     if (selectedMeasure.dataSetType === 'MEASURE' && reportDetails?.reportDetails?.measures.length) {
  //       const fieldObj = reportDetails?.reportDetails?.measures.find(meas => meas?.fieldName.split('.')[1] === selectedMeasure.name)

  //       if (fieldObj) {
  //         if (fieldObj?.isHidden) {
  //           return (<MenuItem className="text-plain font-weight-500" onClick={(e) => handleHideReportColumn(false)}>
  //             Unhide Column
  //           </MenuItem>
  //           )
  //         }
  //         else {
  //           return (<MenuItem className="text-plain font-weight-500" onClick={(e) => handleHideReportColumn(true)}>
  //             Hide Column
  //           </MenuItem>
  //           )
  //         }
  //       }
  //     }
  //     else if (selectedMeasure.dataSetType === 'DIMENSION' && reportDetails?.reportDetails?.dimensions.length) {
  //       const fieldObj = reportDetails?.reportDetails?.dimensions.find(dim => dim?.fieldName.split('.')[1] === selectedMeasure.name)

  //       if (fieldObj) {

  //         if (fieldObj?.isHidden) {
  //           return (
  //             <MenuItem className="text-plain font-weight-500" onClick={(e) => handleHideReportColumn(false)}>
  //               Unhide Column
  //             </MenuItem>
  //           )
  //         }
  //         else {
  //           return (<MenuItem className="text-plain font-weight-500" onClick={(e) => handleHideReportColumn(true)}>
  //             Hide Column
  //           </MenuItem>
  //           )
  //         }
  //       }
  //     }
  //   }
  // }

  const handleHideReportColumn = (value) => {
    if (selectedMeasure?.dataSetType === 'MEASURE') {
      const reportObj = reportDetails?.reportDetails?.measures.find(meas => meas?.fieldName.split('.')[1] === selectedMeasure?.name)
      reportObj.isHidden = value
    }
    if (selectedMeasure.dataSetType === 'DIMENSION') {
      const reportObj = reportDetails?.reportDetails?.dimensions.find(dim => dim?.fieldName.split('.')[1] === selectedMeasure?.name)
      reportObj.isHidden = value
    }

    setAnchorEl(null)
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  /* useEffect(() => {
    console.log(reportDetails,selectedDataSetObj)
  },[reportDetails]) */

  const handleJoinFlagChange = () => {
    if (!reportDetails?.reportDetails?.joinFlag) {
      reportDetails.reportDetails.joinFlag = true
    }
    else {
      reportDetails.reportDetails.joinFlag = false
    }
    let repObj = clearSelections(reportDetails,selectedDataSetObj)
    updateReportDetails({ reportDetails: repObj.reportDetails })
  }

  const handleReportDisplayName = (measure) => {
    if (measure?.dataSetType === 'MEASURE') {
      const exist = reportDetails?.reportDetails?.measures.find(meas => meas?.fieldId === measure?._id);
      if (exist) {
        exist.displayName = measure?.displayName
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
      }
    }
    else {
      const exist = reportDetails?.reportDetails?.dimensions.find(dim => dim?.fieldId === measure?._id);
      if (exist) {
        exist.displayName = measure?.displayName
        updateReportDetails({ reportDetails: reportDetails.reportDetails })
      }
    }
  }

  const handleMenuItemsAuth = (type) => {
    const menuItemsObj = {
      edit: <MenuItem className="text-plain font-weight-500" onClick={(e) => getCalculatedMeasures(e)}> Edit Calculated Field </MenuItem>,
      remove: <MenuItem className="text-plain font-weight-500" onClick={(e) => deleteCalculatedFields(e)}> Remove Calculated Field </MenuItem>
    }
    const currentUser = DecryptData(localStorage.getItem('s_uuid'))
    const currentRole = DecryptData(localStorage.getItem('role'))
    if (currentRole?.toLowerCase() === 'superadmin' || (currentUserType && currentUserType?.customFieldCreation !== false) && selectedMeasure?.createdBy === currentUser) {
      return menuItemsObj[type]
    }
    return null
  }


  const handleFieldDetails = e => {
    let { name, value } = e.target
    let newMeasureObject = { ...selectedMeasure, [name]: value }
    setSelectedMeasure(newMeasureObject)
  }

  const measureAndDimension = useMemo(() => {
    const measures = [];
    const dimensions = [];

    measureList?.forEach(measure => {
      if (measure?.dataSetType === 'MEASURE') {
        measures.push(measure)
      }
      else {
        dimensions.push(measure)
      }
    });

    //sorting measures and dimensions
    const sortedDimensions = dimensions.sort((a, b) => {
      if (a.type > b.type) return 1;
      if (a.type < b.type) return -1;

      const aName = (a.displayName || a.name).toLowerCase();
      const bName = (b.displayName || b.name).toLowerCase();

      if (aName < bName) return -1;
      if (aName > bName) return 1;

      return 0;
    });

    const sortedMeasures = measures.sort((a, b) => {
      const aName = (a.displayName || a.name).toLowerCase();
      const bName = (b.displayName || b.name).toLowerCase();

      if (aName < bName) return -1;
      if (aName > bName) return 1;
      return 0;
    });

    return { sortedMeasures, sortedDimensions }
  }, [measureList])

  useEffect(() => {
    if(selectedDataSetObj?.customJoin && selectedDataSetObj?.customJoin.constructor === Array && selectedDataSetObj?.customJoin.length > 0){
      setShowJoinFlag(true)
    }else{
      setShowJoinFlag(false)
    }
  },[selectedDataSetObj])

  return (
    <RootStyle>
      <div>
        <Box width="100%" height="100%">

          <Box>
            {
              showJoinFlag &&
              <FormControlLabel
                control={
                    <Switch
                        name="showJoin"
                        checked={
                            reportDetails?.reportDetails?.joinFlag === null || reportDetails?.reportDetails?.joinFlag === undefined
                                ? false
                                : reportDetails?.reportDetails?.joinFlag
                        }
                        onChange={handleJoinFlagChange}
                    />
                }
                label="Show Additional Fields"
              />
            }
            
            <Typography className="report-form-label font-weight-normal" variant="subtitle1" display="block"> Dataset </Typography>

            <Autocomplete
              className="cm_rprt_setting_content report_form_ui_input_select pl-0 report_search_visual_dataset"
              classes={{ input: classes.autoCompleteInp }}
              size='small'
              ListboxProps={{
                className: "visual-dataset-list"
              }}
              disablePortal
              disableClearable
              popupIcon={<Box className="form_icon"><DropDownIcon className="search_end_icon" /></Box>}
              onChange={handleConfirmDataSetChange}
              value={selectedDataSetObj?._id ? selectedDataSetObj : null}
              options={filteredDataSetList?.length ? filteredDataSetList : datasetOptions}
              isOptionEqualToValue={(option) => option._id === selectedDataSetObj._id}
              renderInput={(params) => <TextField onChange={handleDatasetSearch} {...params} />}
              filterOptions={(x) => x}
              loading={loadingDataset}
              renderOption={(props, obj) => {
                return (
                  <ListItem {...props} value={obj._id} button
                    className={classes.searchFieldListItem + " report-list-item"} alignItems="flex-start"
                    disabled={datasetSelectedId === obj._id ? true : false}
                  >
                    <ListItemIcon sx={{ mt: '4px', mr: '8px' }}> <ParseSvgIcon component={VisualizeIcon} /> </ListItemIcon>
                    <Grid container >
                      <Grid item xs={12}>
                        <Typography variant="body2" className="text-plain"> {obj?.displayName ? obj?.displayName : obj?.dataSetName} </Typography>
                      </Grid>
                      <Grid item xs={12} className="text-sub-grid">
                        <Typography variant="subtitle2" className="text-sub"> {obj.description ?? 'No description'} </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                )
              }}
            />
          </Box>

          <Box width="100%" height="100%" display="block" mt={2}>
            <Typography className="report-form-label font-weight-normal" variant="button" display="block" mt={2} > Field list </Typography>
            <TextField className=" cm_rprt_setting_content report_form_ui_input report_input_field_list" type="search" size="small" placeholder="Search field"
              onChange={handleSearchMeasure}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                  </InputAdornment>
                ),
                classes: {
                  input: classes.formInput,
                  adornedEnd: classes.bgWhite + " form_input"
                }
              }} />
          </Box>
          <div className={`${classes.reportFieldList}`}>
            <ListSubheader className={classes.grey_bg} component="h2" id="nested-list-subheader">
              MEASURES
            </ListSubheader>
            <List component="nav">
              {measureAndDimension.sortedMeasures.map((measure, i) => (
                !measure?.joinHiddenField &&
                <ListItem key={i} button className={setClassNameMeasureReport(measure) + " report-list-item report-visualise-field-listitem " + classes.searchFieldListItem} onClick={() => clickMeasureListHandler(measure)}
                  alignItems="flex-start">
                  <ListItemIcon sx={{ mt: '0px', mr: '8px' }} className={classes.searchFieldListIcon}>
                    {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                  </ListItemIcon>

                  <Grid container className='report-visualise-field-listitem-content'>
                    <Grid item xs={12}>
                      <Typography className="text-plain"> {measure?.dataset ? (measure.dataset._id != selectedDataSetObj._id ? ( `${(measure?.displayName ?? measure?.name)} (${measure.dataset.dataSetName})`): ( measure?.displayName ?? measure?.name)) : ( measure?.displayName ?? measure?.name)} </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub report-visualise-field-listitem-subtitle"}>{measure?.description}  {(measure?.comment) ? `(${measure?.comment})` : ''} </Typography>
                    </Grid>
                  </Grid>

                  <Button className={classes.fieldBtn + " no-hover height-100 py-0 more-icon"} onClick={(e) => handleClick(e, measure)}>
                    <MoreIcon className={classes.searchFieldListMoreIcon + " text-icon"} />
                  </Button>
                </ListItem>
              ))}
            </List>


            <ListSubheader className={classes.grey_bg} component="h2" id="nested-list-subheader">
              DIMENSIONS
            </ListSubheader>
            <List component="nav">
              {measureAndDimension.sortedDimensions.map((measure, i) => (
                !measure?.joinHiddenField &&
                <ListItem key={i} button className={setClassNameMeasureReport(measure) + " report-list-item report-visualise-field-listitem " + classes.searchFieldListItem} onClick={() => clickMeasureListHandler(measure)}
                  alignItems="flex-start">
                  <ListItemIcon sx={{ mt: '0px', mr: '8px' }} className={classes.searchFieldListIcon}>
                    {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                  </ListItemIcon>

                  <Grid container className='report-visualise-field-listitem-content'>
                    <Grid item xs={12}>
                      <Typography className="text-plain"> {measure?.dataset ? (measure.dataset._id != selectedDataSetObj._id ? ( `${(measure?.displayName ?? measure?.name)} (${measure.dataset.dataSetName})`): ( measure?.displayName ?? measure?.name)) : ( measure?.displayName ?? measure?.name)}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub report-visualise-field-listitem-subtitle"}>{measure?.description}  {(measure?.comment) ? `(${measure?.comment})` : ''} </Typography>
                    </Grid>
                  </Grid>

                  <Button className={classes.fieldBtn + " no-hover height-100 py-0 more-icon"} onClick={(e) => handleClick(e, measure)}>
                    <MoreIcon className={classes.searchFieldListMoreIcon + " text-icon"} />
                  </Button>
                </ListItem>
              ))}
            </List>

            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              className={classes.fieldMenu}
              // getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              {/* {
                reportDetails?.reportDetails && reportDetails?.reportDetails?.chartType === 'table' ?
                  renderHideColumnMenu() : null
              } */}

              <MenuItem className="text-plain font-weight-500" onClick={(e) => editMeasureDescription('open')}> Edit Name/Description </MenuItem>

              {selectedMeasure?.calculatedField && (
                <div>
                  { selectedMeasure.dataSetId == selectedDataSetObj._id && handleMenuItemsAuth('edit')}
                  {selectedMeasure.dataSetId == selectedDataSetObj._id && handleMenuItemsAuth('remove')}

                  <MenuItem className="text-plain font-weight-500  space-between pr-0">Change Format<Button className="no-hover height-100 py-0" aria-controls="format-menu" aria-haspopup="true" onClick={e => handleFormatMenu(e)} style={{ color: 'gray' }}>
                    <ExpandMoreOutlinedIcon />
                  </Button>
                    <Menu
                      id="format-menu"
                      anchorEl={formatAnchorEl}
                      keepMounted
                      open={Boolean(formatAnchorEl)}
                      onClose={handleFormatClose}
                      // onClick={handleFormatSelect}
                    >
                      <MenuItem onClick={(e) => handleSubFormatSelect(e, 'number')}className="text-plain font-weight-500" value="number" handle >Number</MenuItem>
                      <MenuItem onClick={(e) => handleSubFormatSelect(e, 'compactNumber')}className="text-plain font-weight-500" value="compactNumber" handle >Compact Number</MenuItem>
                      <MenuItem onClick={(e) => handleSubFormatSelect(e, 'percentage')} className="text-plain font-weight-500" value="percentage">Percent</MenuItem>
                      <MenuItem className="text-plain font-weight-500  space-between pr-0">Currency<Button className="no-hover height-100 py-0" aria-controls="sub-format-menu" aria-haspopup="true" onClick={e => handleSubFormatCurrencyMenu(e)} style={{ color: 'gray' }}>
                        <ExpandMoreOutlinedIcon />
                        </Button>
                        <Menu
                          id="sub-format-menu"
                          anchorEl={subFormatCurrencyAnchorEl}
                          keepMounted
                          open={Boolean(subFormatCurrencyAnchorEl)}
                          onClose={handleFormatClose}
                          onClick={(e) => handleSubFormatSelect(e, 'currency')}
                        >
                          {
                            CURRENCIES.map(symbol => (
                              <MenuItem key={`symbol-${symbol}`} className="text-plain font-weight-500" value={symbol} >{symbol}</MenuItem>
                            ))
                          }
                        </Menu>
                      </MenuItem>
                      <MenuItem className="text-plain font-weight-500  space-between pr-0">Time<Button className="no-hover height-100 py-0" aria-controls="sub-format-menu" aria-haspopup="true" onClick={e => handleSubFormatMenu(e)} style={{ color: 'gray' }}>
                        <ExpandMoreOutlinedIcon />
                        </Button>
                        <Menu
                          id="sub-format-menu"
                          anchorEl={subFormatAnchorEl}
                          keepMounted
                          open={Boolean(subFormatAnchorEl)}
                          onClose={handleFormatClose}
                          onClick={(e) => handleSubFormatSelect(e, 'time')}
                        >
                          <MenuItem className="text-plain font-weight-500" value={'seconds'} >Seconds</MenuItem>
                          <MenuItem className="text-plain font-weight-500" value={'minutes'}>Minutes</MenuItem>
                          <MenuItem className="text-plain font-weight-500" value={'hours'}>Hours</MenuItem>
                        </Menu>
                      </MenuItem>
                      </Menu>
                  </MenuItem>                  
                </div>
              )
              }
              {
                selectedMeasure?.comment && (
                  <div>
                    <MenuItem className="text-plain font-weight-500 space-between pr-0" handle >Change Format <Button className="no-hover height-100 py-0" aria-controls="date-select-menu" aria-haspopup="true" onClick={e => handleDateSelectMenu(e)} style={{ color: 'gray' }}>
                      <ExpandMoreOutlinedIcon />
                    </Button>
                      <Menu
                        id="date-select-menu"
                        anchorEl={dateSelectAnchorEl}
                        keepMounted
                        open={Boolean(dateSelectAnchorEl)}
                        onClose={handleDateSelectClose}
                        onClick={handleTimeFormatSelect}
                      >
                        <MenuItem className="text-plain font-weight-500" value="number">Number</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="hh:mm:ss">hh:mm:ss</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="HH:MM:SS">Time String</MenuItem>
                      </Menu>
                    </MenuItem>
                  </div>

                )
              }
              {
                selectedMeasure?.type === 'time' && (
                  <div>
                    <MenuItem className="text-plain font-weight-500 space-between pr-0" handle >Change Format <Button className="no-hover height-100 py-0" aria-controls="date-select-menu" aria-haspopup="true" onClick={e => handleDateSelectMenu(e)} style={{ color: 'gray' }}>
                      <ExpandMoreOutlinedIcon />
                    </Button>
                      <Menu
                        id="date-select-menu"
                        anchorEl={dateSelectAnchorEl}
                        keepMounted
                        open={Boolean(dateSelectAnchorEl)}
                        onClose={handleDateSelectClose}
                        onClick={handleDateFormatSelect}
                      >
                        <MenuItem className="text-plain font-weight-500" value="YYYY-MM-DD">{moment().format('YYYY-MM-DD')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="MM-DD-YYYY">{moment().format('MM-DD-YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="DD-MM-YYYY">{moment().format('DD-MM-YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY-MM-DD hh:mm:ss">{moment().format('YYYY-MM-DD hh:mm:ss')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY-MM-DD HH:mm:ss">{moment().format('YYYY-MM-DD HH:mm:ss')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY-MM-DD hh:mm a">{moment().format('YYYY-MM-DD hh:mm a')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY-MM-DD hh:mm A">{moment().format('YYYY-MM-DD hh:mm A')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="MMMM DD, YYYY">{moment().format('MMMM DD, YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="DD MMM, YYYY">{moment().format('DD MMM, YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="hh:mm a DD MMM, YYYY">{moment().format('hh:mm a DD MMM, YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="hh:mm A DD MMM, YYYY">{moment().format('hh:mm A DD MMM, YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="DD MMM, hh:mm a">{moment().format('DD MMM, hh:mm a')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="DD MMM, hh:mm A">{moment().format('DD MMM, hh:mm A')}</MenuItem>

                        <MenuItem className="text-plain font-weight-500" value="YYYY/MM/DD">{moment().format('YYYY/MM/DD')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="MM/DD/YYYY">{moment().format('MM/DD/YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="DD/MM/YYYY">{moment().format('DD/MM/YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY/MM/DD hh:mm:ss">{moment().format('YYYY/MM/DD hh:mm:ss')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY/MM/DD HH:mm:ss">{moment().format('YYYY/MM/DD HH:mm:ss')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY/MM/DD hh:mm a">{moment().format('YYYY/MM/DD hh:mm a')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="YYYY/MM/DD hh:mm A">{moment().format('YYYY/MM/DD hh:mm A')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="MMMM/DD/YYYY">{moment().format('MMMM/DD/YYYY')}</MenuItem>
                        <MenuItem className="text-plain font-weight-500" value="DD/MMM/YY">{moment().format('DD/MMM/YY')}</MenuItem>
                        {/* <MenuItem className="text-plain font-weight-500" value="DD/MM/YY">DD/MM/YY</MenuItem> */}

                      </Menu>
                    </MenuItem>
                  </div>
                )
              }
            </Menu>

          </div>

          <Box className="report-new-charts">
            <GraphTypes setChartHandler={setChartHandler} reportDetails={reportDetails} selectedChart={selectedChart} setSelectedChart={setSelectedChart} />
          </Box>
          <Box className="report-new-charts">
            <StaticGraphTypes setChartHandler={setChartHandler} reportDetails={reportDetails} selectedChart={selectedChart} setSelectedChart={setSelectedChart} />
          </Box>
        </Box>

        {(openPopup || isCalculatedFieldOpen) ? <CalculatedFieldsV2
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          selectedDataset={reportDetails?.reportDetails?.dataSetId?._id}
          isEdit={isEditCalculatedFields}
          fieldName={calculatedField}
          fieldValue={calculatedValue}
          displayCalculatedField={displayCalculatedField}
          calculatedDisplayName={calculatedDisplayName}
          calculatedDescription={calculatedDescription}
          measureId={measureId}
          fetchMeasureList={fetchMeasureList}
          closeCalcltdFldDialog={closeCalcltdFldDialog}
          reportDetails={reportDetails?.reportDetails}
        /> : null}

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="modal-root"
          open={confirmDatasetChange}
          closeAfterTransition
        >
          <Fade in={confirmDatasetChange}>
            <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
              <Box className="modal-content-simple">
                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Changing Dataset Will Reset Measures/Dimensions/Filters Selection. Are you sure to change it?`}</Typography>
                <Box className="modal-footer-simple">
                  <Button onClick={() => handleSubmitDataSetChange({ type: 'cancel' })} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                  <Button onClick={() => handleSubmitDataSetChange({ type: 'change' })} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Change </Button>
                </Box>
              </Box>
            </Box>
          </Fade>
        </Modal>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="modal-root"
          open={confirmDataSourceChange}
          closeAfterTransition
        >
          <Fade in={confirmDataSourceChange}>
            <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
              <Box className="modal-content-simple">
                <Typography variant="subtitle1" className="modal-heading-title-simple">{`Changing DataSource Will Reset Measures/Dimensions/Filters/Dataset Selection. Are you sure to change it?`}</Typography>
                <Box className="modal-footer-simple">
                  <Button onClick={() => handleSubmitDataSourceChange({ type: 'cancel' })} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                  <Button onClick={() => handleSubmitDataSourceChange({ type: 'change' })} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Change </Button>
                </Box>
              </Box>
            </Box>
          </Fade>
        </Modal>



        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="modal-root"
          open={editMeasureObj?.openPopup ?? false}
          closeAfterTransition
        >
          <Fade in={editMeasureObj?.openPopup}>
            <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
              <Box className="modal-header" >
                <Typography variant="subtitle1" className="modal-header-title" >{`Update Field`}</Typography>
              </Box>
              <Box className="modal-content">
                <Typography className="text-small label" variant="p">Field Name</Typography>
                <TextField onChange={handleFieldDetails} value={selectedMeasure?.displayName === undefined ? selectedMeasure?.name : selectedMeasure?.displayName} name="displayName" className="report_form_ui_input width-100 mb-1" placeholder="" /> <br />
                <Typography className="text-small label" variant="p">Field Description</Typography>
                <TextField onChange={handleFieldDetails} value={selectedMeasure?.description} name="description" className="report_form_ui_input width-100" placeholder="" />

                <Box className="modal-footer text-right">
                  <Button onClick={() => editMeasureDescription('cancel')} color="error" className="report_form_ui_btn mr-2 cancel" variant="outlined" > Cancel </Button>
                  <Button onClick={() => editMeasureDescription('submit')} color="primary" autoFocus className="report_form_ui_btn submit" variant="contained"> Save </Button>
                </Box>
              </Box>

            </Box>
          </Fade>
        </Modal>
        <Popup title={`Are you sure to delete this Measure "${selectedMeasure?.displayName || selectedMeasure?.name}" ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete}>
          <DialogActions>
            <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
            <Button onClick={submitDeleteField} color="error" autoFocus>Delete</Button>
          </DialogActions>
        </Popup>

      </div>
    </RootStyle>
  );
}



ReportVisualizeSettings.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};
